import { Injectable } from '@angular/core';
import {
  Rpfi15EmployeeGroup,
  Rpfi15Row,
  Rpfi15TableResult,
  Rpfi15Totals,
} from '../../models/report/rpfi15.model';

@Injectable({ providedIn: 'root' })
export class MapperRpfi15Service {
  mapTable(res: unknown): Rpfi15TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      groups: groups.map((g) => this.mapGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapGroup(dto: unknown): Rpfi15EmployeeGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const rows = (g['rows'] ?? g['Rows'] ?? []) as unknown[];
    return {
      openUserId: Number(g['openUserId'] ?? g['OpenUserId'] ?? 0),
      employeeName: String(g['employeeName'] ?? g['EmployeeName'] ?? ''),
      rows: rows.map((r) => this.mapRow(r)),
      shiftCount: Number(g['shiftCount'] ?? g['ShiftCount'] ?? 0),
      sumParkingQty: Number(g['sumParkingQty'] ?? g['SumParkingQty'] ?? 0),
      sumParkingAmount: Number(g['sumParkingAmount'] ?? g['SumParkingAmount'] ?? 0),
      sumCash: Number(g['sumCash'] ?? g['SumCash'] ?? 0),
      sumQr: Number(g['sumQr'] ?? g['SumQr'] ?? 0),
    };
  }

  private mapRow(dto: unknown): Rpfi15Row {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      openDate: (r['openDate'] ?? r['OpenDate'] ?? null) as string | null,
      employeeName: String(r['employeeName'] ?? r['EmployeeName'] ?? ''),
      gateName: String(r['gateName'] ?? r['GateName'] ?? ''),
      shiftNo: String(r['shiftNo'] ?? r['ShiftNo'] ?? ''),
      timeIn: (r['timeIn'] ?? r['TimeIn'] ?? null) as string | null,
      timeOut: (r['timeOut'] ?? r['TimeOut'] ?? null) as string | null,
      parkingQty: Number(r['parkingQty'] ?? r['ParkingQty'] ?? 0),
      parkingAmount: Number(r['parkingAmount'] ?? r['ParkingAmount'] ?? 0),
      cash: Number(r['cash'] ?? r['Cash'] ?? 0),
      qr: Number(r['qr'] ?? r['Qr'] ?? 0),
    };
  }

  private mapTotals(dto: unknown): Rpfi15Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      shiftCount: Number(t['shiftCount'] ?? t['ShiftCount'] ?? 0),
      sumParkingQty: Number(t['sumParkingQty'] ?? t['SumParkingQty'] ?? 0),
      sumParkingAmount: Number(t['sumParkingAmount'] ?? t['SumParkingAmount'] ?? 0),
      sumCash: Number(t['sumCash'] ?? t['SumCash'] ?? 0),
      sumQr: Number(t['sumQr'] ?? t['SumQr'] ?? 0),
      grandTotal: Number(t['grandTotal'] ?? t['GrandTotal'] ?? 0),
    };
  }
}
